/** Use these keys with useHelpInfoBox; do not hardcode or invent new keys. */
export enum HELP_BOX_DISMISS_KEYS {
  HOUSEHOLD_COMPOSITION = 'householdCompositionHelpBoxDismiss',
  HOUSEHOLD_MEMBERS_PAGE = 'householdMembersPageHelpBoxDismiss',
}

export enum HOUSEHOLD_STRUCTURE_STEPS {
  HOUSEHOLDS_LIST = 'HOUSEHOLDS_LIST',
  HOUSEHOLD_DISPLAY = 'HOUSEHOLD_DISPLAY',
  ADD_MEMBER = 'ADD_MEMBER',
  EDIT_MEMBER = 'EDIT_MEMBER',
  MEMBER_DETAILS = 'MEMBER_DETAILS',
}
export const fadeDuration = 600;
export const fadeStyle = {
  animation: `fadeIn ${fadeDuration}ms ease-in-out`,
  '@keyframes fadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
};
